module.exports = __webpack_public_path__ + "img/sc.1112fcce.png";